export default __webpack_public_path__ + "static/media/stats.d54e27a2.png";